import { AllModules } from 'ag-grid-enterprise'
import { mapGetters } from 'vuex'
import DataLoading from './components/DataLoading'
import DataNoRow from './components/DataNoRow'

import {SORT_ICONS} from '@/pages/components/ag-grid/Icons'

export default function () {
  let _params = null
  return {
    data () {
      return {
        modules: AllModules,
        gridOptions: null,
        gridApi: null,
        domLayout: 'autoHeight',
        defaultColDef: {
          suppressMenu: true,
          sortable: true,
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          filter: true,
          resizable: true,
        },
        overlayLoadingTemplate: null,
        overlayNoRowsTemplate: null,
        loadingOverlayComponent: null,
        loadingOverlayComponentParams: {},
        noRowsOverlayComponent: null,
        noRowsOverlayComponentParams: {},
        frameworkComponents: null
      }
    },
    computed: {
      ...mapGetters('locale', [
        'locale'
      ])
    },
    methods: {
      setGridParams(params) {
        _params = params
      },
      fitGrid () {
        if (_params) {
          _params.api.sizeColumnsToFit();
        }
      }
    },
    watch: {
      locale () {
        if (this.setColumn) {
          this.setColumn()
          this.fitGrid()
        }
      }
    },
    beforeMount() {
      this.frameworkComponents = {
        loadingOverlayComponent: DataLoading,
        noRowOverlayComponent: DataNoRow
      };
      this.loadingOverlayComponent = 'loadingOverlayComponent'
      this.noRowsOverlayComponent = 'noRowOverlayComponent'
      this.gridOptions = {
        icons: {
          ...SORT_ICONS
        }
      };
      if (this.setColumn) {
        this.setColumn()
      }
    },
    mounted() {
      this.gridApi = this.gridOptions.api;
      this.gridColumnApi = this.gridOptions.columnApi;
      window.addEventListener("resize", this.fitGrid);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.fitGrid);
    },
  }
}


// WEBPACK FOOTER //
// ./src/pages/mixin/AgGrid.mixin.js